export default __webpack_public_path__ + "static/media/celestial_1.025a705f.png";